import React from 'react';
export function PricingSection() {
  return <section className="w-full" data-id="element-249">
      {/* Dark top section */}
      <div className="bg-[#1a1f2e] px-4 md:px-8 pt-16 pb-8" data-id="element-250">
        <div className="max-w-[800px] mx-auto text-center" data-id="element-251">
          {/* Title */}
          <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-[42px] font-bold text-white leading-tight mb-3" data-id="element-252">
            Tu Negocio "Llave en Mano"
          </h2>
          <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-253"></div>

          {/* Subtitle */}
          <p className="font-['Montserrat',_sans-serif] text-[#ccc] text-base md:text-lg mb-10" data-id="element-254">
            Todo lo que necesitás para facturar esta misma semana. Un solo pago,
            acceso de por vida.
          </p>
        </div>
      </div>

      {/* Product Image - full width no borders */}
      <div className="bg-[#1a1f2e] px-0" data-id="element-255">
        <div className="max-w-[800px] mx-auto" data-id="element-256">
          <img src="https://cdn.magicpatterns.com/uploads/pGwbTdaNpQ87wgA7t1rRzw/Captura_de_pantalla_2026-04-30_a_las_9.02.10_p._m..png" alt="Viandas Rentables - Sistema completo" className="w-full h-auto object-cover" data-id="element-257" />
        </div>
      </div>

      {/* Dark bottom section - Pricing Card */}
      <div className="bg-[#1a1f2e] px-4 md:px-8 pt-8 pb-16" data-id="element-258">
        <div className="max-w-[500px] mx-auto" data-id="element-259">
          <style data-id="element-260">
            {`
              @keyframes shimmer {
                0% { background-position: -200% 0; }
                100% { background-position: 200% 0; }
              }
              .pricing-card-glow {
                position: relative;
                border: 2px solid rgba(250, 204, 21, 0.4);
                box-shadow: 0 0 20px rgba(250, 204, 21, 0.15), 0 0 40px rgba(250, 204, 21, 0.08), inset 0 0 20px rgba(250, 204, 21, 0.05);
              }
              .pricing-card-glow::before {
                content: '';
                position: absolute;
                inset: -2px;
                border-radius: 1rem;
                padding: 2px;
                background: linear-gradient(90deg, transparent, rgba(250,204,21,0.4), transparent);
                background-size: 200% 100%;
                animation: shimmer 3s linear infinite;
                -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                -webkit-mask-composite: xor;
                mask-composite: exclude;
                pointer-events: none;
              }
            `}
          </style>
          <div className="pricing-card-glow bg-[#232a3b] rounded-2xl p-8 md:p-10 text-center" data-id="element-261">
            {/* Old Price */}
            <p className="font-['Montserrat',_sans-serif] text-[#888] text-lg line-through mb-1" data-id="element-262">
              $89.900 ARS
            </p>

            {/* New Price */}
            <p className="font-['Playfair_Display',_serif] text-[#facc15] text-5xl md:text-6xl font-bold mb-4" data-id="element-263">
              $6.900 ARS
            </p>

            {/* Savings Badge */}
            <div className="inline-block bg-[#facc15] rounded-full py-2 px-6 mb-6" data-id="element-264">
              <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] font-extrabold text-sm md:text-base uppercase" data-id="element-265">
                Ahorrá $83.000 (92% OFF)
              </p>
            </div>

            {/* Trust badges */}
            <div className="flex justify-center gap-8 mb-8" data-id="element-266">
              <div className="text-center" data-id="element-267">
                <p className="font-['Montserrat',_sans-serif] text-white text-base md:text-lg" data-id="element-268">
                  🔒 Pago
                  <br data-id="element-269" />
                  Seguro
                </p>
              </div>
              <div className="text-center" data-id="element-270">
                <p className="font-['Montserrat',_sans-serif] text-white text-base md:text-lg" data-id="element-271">
                  ⚡ Entrega
                  <br data-id="element-272" />
                  Inmediata
                </p>
              </div>
            </div>

            {/* What's included */}
            <div className="bg-[#1a1f2e] rounded-xl p-6 space-y-5 text-left border border-[#333d52]" data-id="element-273">
              <div className="flex items-start gap-3" data-id="element-274">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-275">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-276">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-277" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-278">
                  Ebook Central{' '}
                  <span className="font-bold" data-id="element-279">Viandas Rentables</span>
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-280">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-281">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-282">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-283" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-284">
                  <span className="font-bold" data-id="element-285">Kit Pro 7x1</span> (Herramientas
                  de Negocio)
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-286">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-287">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-288">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-289" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-290">
                  <span className="font-bold" data-id="element-291">10 Bonos de Negocios</span>{' '}
                  Adicionales
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-292">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-293">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-294">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-295" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-296">
                  Acceso{' '}
                  <span className="font-bold" data-id="element-297">
                    De Por Vida + Actualizaciones
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}